import { render, staticRenderFns } from "./edit_attachments_v1.vue?vue&type=template&id=36b906f3&scoped=true"
import script from "./edit_attachments_v1.vue?vue&type=script&lang=js"
export * from "./edit_attachments_v1.vue?vue&type=script&lang=js"
import style0 from "./edit_attachments_v1.vue?vue&type=style&index=0&id=36b906f3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b906f3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
